export enum WeatherConditionType {
    Clear = 0,
    Cloudy = 1,
    Fog = 2,
    RainingSnowing = 3
}